import "./upcomingHearings.css";
import { useNavigate } from "react-router-dom";
import {
  PlusCircle,
  UserPlus,
  Upload,
  FileText,
  Zap,
} from "lucide-react";

const actions = [
  {
    title: "Add Case",
    icon: <PlusCircle size={24} />,
    route: "/portal/addcase",
  },
  {
    title: "Add Client",
    icon: <UserPlus size={24} />,
    route: "/portal/MyClients",
  },
  {
    title: "Upload Document",
    icon: <Upload size={24} />,
    route: "/portal/MyFiles",
  },
  {
    title: "Create Invoice",
    icon: <FileText size={24} />,
    route: "/portal/create-invoice"
  },
];

export default function QuickActions() {
  const navigate = useNavigate();
  return (
    <div className="dashboard-panel quick-actions">

      <div className="panel-title">
        <Zap size={17} />
        Quick Actions
      </div>

      <div className="quick-grid">
        {actions.map((item) => (
         <div
  className="quick-card"
  key={item.title}
  onClick={() => navigate(item.route)}
>
            <div className="quick-icon">
              {item.icon}
            </div>

            <span>{item.title}</span>
          </div>
        ))}
      </div>

    </div>
  );
}